import sales from '@/locales/en/sales/sales.locales';

export default {
    ...sales,
};
